import { Children } from 'react';

import { Divider } from '../../../../components/Divider';

export type RowProps = {
	divider?: boolean;
	align?: 'start' | 'end' | 'center' | 'stretch';
	className?: string;
	left?: React.ReactNode;
	right?: React.ReactNode;
	children?: [left: React.ReactNode, right: React.ReactNode];
};

export const Row: React.FC<RowProps> = ({
	align = 'end',
	className,
	left,
	right,
	children,
	divider
}) => {
	const [l, r] = Children.toArray(children);

	return (
		<div
			className={`row no-gutters align-items-${align} order-card-row${
				className ? ` ${className}` : ''
			}`}
		>
			<div className="col">{left ?? l}</div>

			<div className="w-100 d-ms-none">
				{divider && <Divider my={1} pullOut={3} />}
			</div>

			<div className="col-auto text-ms-right mt-1 mt-ms-0">
				{right ?? r}
			</div>
		</div>
	);
};
